import { CityLandingPage } from "../components/CityLandingPage";

export function WebdesignSenftenberg() {
  return (
    <CityLandingPage city="Senftenberg" citySlug="senftenberg" variant="webdesign" />
  );
}
